import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { Table } from '../../components';
import { DATE_YMD, STUDENT_STATUS_STRING, STUDENT_STATUS_MAPPER } from '../../core/configs/constants';
import { useStore } from '../../core/utils/hook';
import moment from 'moment';

// GA screen for the 受講者数 count: keeps the original behaviour — lists all (non-resigned)
// learners of the attendance code, view-only. The 承認待ち label is added for status 3.
// Reused for the 確認中数 count (#18022) through `scope='confirming'`: same table, same columns,
// only the subset returned by the BE differs.
const StudentListByAttendanceCodeScreen = observer(({ scope = 'approved' }) => {

    // params, query
    const { id } = useParams();

    // store
    const { groupAdminStore: { getStudentListByAttendanceCode, studentListByAttendanceCode } } = useStore();

    // lifecycle — BE returns the requested subset (approved | confirming); FE only displays.
    useEffect(() => {
        getStudentListByAttendanceCode(id, { scope });
    }, [id, scope])

    // columns table
    const columns = [
        {
            Header: 'ID',
            accessor: 'userId',
            disableSortBy: true,
            Cell: ({ row: { original } }) => {
                return (
                    <div>
                        {original?.userId}
                    </div>
                );
            },
            width: '10%'
        },
        {
            Header: '名前',
            accessor: 'name',
            disableSortBy: true,
            Cell: ({ row: { original } }) => {
                return (
                    <div>
                        {
                            original?.inGroup ?
                                <Link to={`/student-detail/${original.id}`}>{original?.name}</Link> :
                                original?.name
                        }

                    </div>
                );
            },
            width: '25%'
        },
        {
            Header: '薬剤師名簿登録番号',
            accessor: 'pharmacistNumber',
            disableSortBy: true,

            Cell: ({ row: { original } }) => {
                return (
                    <div>
                        {original?.pharmacistNumber}
                    </div>
                );
            },
            width: '15%'
        },
        {
            Header: 'メールアドレス',
            accessor: 'email',
            disableSortBy: true,
            Cell: ({ row: { original } }) => {
                return (
                    <div>
                        { original?.email}
                    </div>
                );
            },
            width: '30%'
        },
        {
            Header: 'ステータス',
            accessor: 'status',
            disableSortBy: true,
            Cell: ({ row: { original } }) => {
                return (
                    <div>
                        {STUDENT_STATUS_MAPPER[original?.status] ?? STUDENT_STATUS_STRING.CONFIRMING}
                    </div>
                );
            },
            width: '10%'
        },
        {
            Header: '受講開始日',
            accessor: 'course_period',
            disableSortBy: true,
            className: 'min-width-150',
            Cell: ({ row: { original } }) => {
                return (
                    <div style={{
                        minWidth: 'fit-content',
                        display: 'inline-block'
                    }}>
                        {original.coursePeriod ? moment(original.coursePeriod).format(DATE_YMD) : ''}
                    </div>
                );
            },
            width: '30%'
        }
    ]

    return(
        <div id='main' className='wrapper main-student-list main-view-student-detail main-student-list'>
            <section className='content-student-list'>
                <div className='container'>
                    {/* Suffix keeps the two drill-downs apart: the 受講者数 list and the 確認中数 list
                        share this screen and otherwise render an identical heading. */}
                    <h1 className='title-primary'>
                        受講コード #{studentListByAttendanceCode?.attendanceCode} 別の受講者リスト
                        {scope === 'confirming' ? '（確認中）' : ''}
                    </h1>
                    <Table
                        columns={columns}
                        data={studentListByAttendanceCode?.listUser || []}
                        disablePaging={true}
                        scrollHorizontalWidth={'768px'}
                        className='lst-attendance-table mg-t-35'
                    />
                </div>
            </section>
        </div>

    )
})

export default StudentListByAttendanceCodeScreen;
